enum ErrorCode {
  Unknown = -1,
  Ok = 0,
  EmailNotFound = 1,
  InvalidPassword = 2,
  RefreshTokenNotFound = 3,
  CredentialExpired = 6,
  UserNotActive = 16,
  WeakPassword = 29,
  EmailAlreadyExists = 30
}

export default ErrorCode;